import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import ForgetPassword from "../pages/Auth/components/ForgetPassword/ForgetPassword";
import Login from "../pages/Auth/components/Login/Login";
import ResetPassword from "../pages/Auth/components/ResetPassword/ResetPassword";
import SetPassword from "../pages/Auth/components/SetPassword/SetPassword";
import Home from "../pages/Dashboard/Home/Home";
import PrescriptionForm from "../pages/Prescription/components/PatientForm/PrescriptionForm";
import ErrorPage from "../utilities/pages/ErrorPage/ErrorPage";
import PrivateRoute from "./PrivateRoute";
import OrganisationProfile from "../pages/Organizations/components/OrganisationProfile/OrganisationProfile";

/**
 * function to return app routes
 * @returns {JSX.Element}
 * @constructor
 */
const AppRoutes = () => {
  return (
    <Router>
      <Switch>
        <Route exact path="/prescription" component={PrescriptionForm} />
        <Route exact path="/login" component={Login} />
        <Route exact path="/setPassword/:id/:token" component={SetPassword} />
        <Route exact path="/forgotPassword" component={ForgetPassword} />
        <Route
          exact
          path="/resetPassword/:id/:token"
          component={ResetPassword}
        />

        {/* common routes */}
        <PrivateRoute exact path="/" component={Home} />

        {/* admin dashboard routes  */}
        <PrivateRoute exact path="/profile/:id" component={Home} />
        <PrivateRoute exact path="/profile/edit/:id" component={Home} />

        <PrivateRoute exact path="/users" component={Home} />
        <PrivateRoute exact path="/users/:id" component={Home} />
        <PrivateRoute exact path="/users/edit/:id" component={Home} />

        <PrivateRoute exact path="/medicineInventory" component={Home} />

        <PrivateRoute exact path="/orgs" component={Home} />
        <PrivateRoute exact path="/orgs/add" component={Home} />
        <PrivateRoute exact path="/orgs/addDepartment" component={Home} />
        <PrivateRoute exact path="/orgs/addDoctor" component={Home} />
        <PrivateRoute exact path="/orgs/addAdmin" component={Home} />
        <PrivateRoute exact path="/orgs/:id" component={OrganisationProfile} />
        <PrivateRoute exact path="/setting" component={Home} />
        <PrivateRoute exact path="/orgs/edit/:id" component={Home} />

        <PrivateRoute exact path="/headorgs" component={Home} />
        <PrivateRoute exact path="/headorgs/add" component={Home} />
        <PrivateRoute exact path="/headorgs/:id" component={Home} />
        <PrivateRoute exact path="/headorgs/edit/:id" component={Home} />
        <PrivateRoute exact path="/profile/:id" component={Home} />
        <PrivateRoute exact path="/profile/edit/:id" component={Home} />

        <PrivateRoute
          exact
          path="/orgs/departments/addPatient"
          component={Home}
        />
        <PrivateRoute
          exact
          path="/orgs/departments/addDoctor"
          component={Home}
        />
        <PrivateRoute
          exact
          path="/orgs/departments/addAdmin"
          component={Home}
        />

        <PrivateRoute exact path="/orgs/departments/:id" component={Home} />
        <PrivateRoute
          exact
          path="/orgs/departments/edit/:id"
          component={Home}
        />
        <PrivateRoute exact path="/orgs/doctors/edit/:id" component={Home} />

        <PrivateRoute exact path="/orgs/doctors/:id" component={Home} />

        <PrivateRoute exact path="/orgs/admins/edit/:id" component={Home} />

        <PrivateRoute exact path="/orgs/admins/:id" component={Home} />

        <PrivateRoute
          exact
          path="/orgs/departments/patients/edit/:id"
          component={Home}
        />
        <PrivateRoute
          exact
          path="/orgs/departments/patients/:id"
          component={Home}
        />

        <PrivateRoute
          exact
          path="/orgs/departments/doctors/edit/:id"
          component={Home}
        />

        <PrivateRoute
          exact
          path="/orgs/departments/doctors/:id"
          component={Home}
        />

        <PrivateRoute
          exact
          path="/orgs/departments/admins/edit/:id"
          component={Home}
        />

        <PrivateRoute
          exact
          path="/orgs/departments/admins/:id"
          component={Home}
        />

        {/* user dashboard routes  */}
        <PrivateRoute exact path="/profile" component={Home} />
        <PrivateRoute exact path="/profile/edit" component={Home} />

        <PrivateRoute exact path="/followup" component={Home} />

        <PrivateRoute exact path="/newUpdates" component={Home} />
        <PrivateRoute exact path="/home" component={Home} />
        <PrivateRoute exact path="/cases/addCase" component={Home} />
        <PrivateRoute exact path="/cases" component={Home} />
        <PrivateRoute exact path="/cases/:id" component={Home} />

        <PrivateRoute exact path="/patients/:id" component={Home} />
        <PrivateRoute exact path="/patients" component={Home} />

        <PrivateRoute exact path="/departments" component={Home} />
        <PrivateRoute exact path="/departments/edit/:id" component={Home} />
        <PrivateRoute exact path="/departments/addPatient" component={Home} />
        <PrivateRoute exact path="/departments/addDoctor" component={Home} />
        <PrivateRoute
          exact
          path="/departments/patients/edit/:id"
          component={Home}
        />
        <PrivateRoute exact path="/departments/patients/:id" component={Home} />
        <PrivateRoute
          exact
          path="/departments/doctors/edit/:id"
          component={Home}
        />
        <PrivateRoute exact path="/departments/doctors/:id" component={Home} />

        <PrivateRoute exact path="/departments/:id" component={Home} />
        <PrivateRoute exact path="/appointments" component={Home} />
        <PrivateRoute exact path="/appointments/add" component={Home} />
        <PrivateRoute exact path="/appointment/insight" component={Home} />

        <PrivateRoute exact path="/prescriptions/add" component={Home} />
        <Route
          component={() => (
            <ErrorPage code={404} message="Sorry! Page Not Found." />
          )}
        />
      </Switch>
    </Router>
  );
};

export default AppRoutes;
